const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'filetype_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_FILETYPES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_FILETYPES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_FILETYPES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_FILETYPES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_FILETYPE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.filetype_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filetypes.js